import React, { Component } from "react";
import Swal from "sweetalert2";
import withReactContent from "sweetalert2-react-content";
import i18n from "../../../../i18n";
import Select2 from "../../../utilities/Form/Select2";
import { Button } from "react-bootstrap";
import cookieManager from "../../../../utils/cookieManager";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEye, faFileExcel } from "@fortawesome/free-solid-svg-icons";
import DataReturn from "./data-return";
const MySwal = withReactContent(Swal);
export class FormReturnGoods extends Component {
  constructor(props) {
    super(props);
    this.state = {
      breadcrumbs: [
        { link: process.env.APP_URL, title: i18n.t("Home"), class: " text-gray-600" },
        { link: null, title: i18n.t("Warehouse"), class: " text-gray-600" },
        { link: null, title: i18n.t("Return Goods"), class: " text-gray-500" },
      ],
      idBranch: null,
      branchCurrent: null,
      branchText: i18n.t("Select Branch"),
      branchList: [],
      setSummary:null,
      dataTaking:null,
      loadingStore:false,
      loadingEmployee:false,
      idStore: null,
      storeCurrent: null,
      storeText: i18n.t("Select Store"),
      storeList: [],
      idEmployee: null,
      employeeCurrent: null,
      employeeText: i18n.t("Select Employee"),
      employeeList: [],
      date:new Date(),
      dataReturn:null,
      progressConvert:false
    }
    this.handlerSelect = this.handlerSelect.bind(this);
    this.handlerDateTime=this.handlerDateTime.bind(this);
  }
  renderError(name) {
    const { isError, errorMessage } = this.props;
    var value = "";
    if (isError) {
      if (errorMessage[name] != undefined) {
        value = errorMessage[name][0];
      }
    }
    return i18n.t(value);
  }
  handlerSelect(e, name, currentState) {
    var key = name;
    var value = null;
    if (e != null) {
      value = e.value;
    }
    this.setState({
        [key]: value,
        [currentState]: e,
      }
    );
  }
  getData(type,extra=()=>{}) {
    const token = cookieManager.getUserToken();
    let params = null;
    let fill = null;
    switch (type) {
      case "getStore":
        fill = "storeList";
        var url = process.env.REST_URL + "helper/get-store";
        var branch =
          this.state.branchCurrent != undefined
            ? this.state.branchCurrent.value
            : null;
        if (branch != null) {
          params = {
            id: branch,
          };
        }

        break;
      case "getEmployee":
        fill = "employeeList";
        var url = process.env.REST_URL + "helper/get-employee";
        var branch =
          this.state.branchCurrent != undefined
            ? this.state.branchCurrent.value
            : null;
        var store =
          this.state.storeCurrent != undefined
            ? this.state.storeCurrent.value
            : null;
        if (branch != null || store != null) {
          params = {
            branch: branch,
            store: store,
          };
        }

        break;
    }

    if (type != null && params != null) {
      axios({
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
        url: url,
        responseType: "json",
        params: params,
      })
        .then((response) => {
          if (response && response.status === 200 && response.data) {
            this.setState({ [fill]: response.data.result },extra);
          }
        })
        .catch((error) => {
          console.log(error);
        });
    }
  }
  handlerDateTime(e,name) {
      var key=name;
      var value=e
      this.setState({
          [key]:value
      })
  }

  renderLoading() {
      Swal.fire({
        title: 'Loading',
        width: "200px",
        heightAuto: true
      });
      Swal.showLoading();
    }
  alertHandler(title, message, icon) {
      Swal.fire({
        title: title,
        html: message,
        icon: icon,
      });
    }
  async convertExcel() {
    if(this.state.employeeCurrent !=null){
      this.setState({progressConvert:true})

      const params={
        date:moment(this.state.date).format('YYYY-MM-DD'),
        idEmployee:this.state.idEmployee,
      }

      var salesName=this.state.employeeCurrent?.label
      var nameFile = 'Report Visiting '+(moment(this.state.date).format('DD MM YYYY'))+' Sales '+salesName ;
       
      this.renderLoading();
      const token = cookieManager.getUserToken();
      axios({
        headers: {
          Authorization: `Bearer ${token}`,
        },
        url: process.env.REST_URL + "sales/report-visit-excel",
        method: "GET",
        params: params,
        responseType: "blob",
      }).then((response) => {
        if (response && response.status === 200 && response.data) {
          Swal.close();
          this.setState({progressConvert:false})
          this.alertHandler('Convert Excel', 'Download Successfully', 'success')
          var urlCreator = window.URL || window.webkitURL;
          const blobUrl = urlCreator.createObjectURL(response.data);
          const link = document.createElement("a");
          link.style.display = "none";
          link.href = blobUrl;
          link.setAttribute("download",
            nameFile +'.xlsx');
          document.body.appendChild(link);
          link.click();
          link.remove();
        } else {
          Swal.close();
        }
      }).catch((error) => {
        this.setState({progressConvert:false})
        this.alertHandler('Convert Excel', 'Internal Server Error', 'info')
      });
    }
      
  }

  showData(){
    const post={
      idEmployee:this.state.idEmployee,
      idBranch:this.state.branchCurrent != null ? this.state.branchCurrent.value : '',
      idStore:this.state.storeCurrent != null ? this.state.storeCurrent.value : '',
    }
    if(this.state.idEmployee !=null && this.state.date!=''){
    }
    
    this.props.getDataGoods(post)

  }

  runSubmit() {
    const summary = this.state.summary;
    const takingGoods = this.state.dataTaking;
    const invalidRow = summary.find((row, index) => {
      return !row.warehouse || !row.warehouse.value;
    });

    const invalidRecord = this.state.summary.find((row, index) => {
        return !row.return || row.return.length  == 0;
    });

    const invalidTotal  = this.state.summary.find((row) => {
      let total = 0;

      const totalReturnQtyConvert = (row.return || [])
        .reduce((sum, r) => sum + (r.qtyConvert || 0), 0);
     
      const maxAllowed = (row.total_convert || 0);
      total = totalReturnQtyConvert + (row.total_sell || 0);
      // console.log('totalReturnQtyConvert',totalReturnQtyConvert)
      // console.log('maxAllowed',maxAllowed)
      // console.log('total',total)
      // console.log(total > maxAllowed)
      // console.log(total > 0)
      return total < maxAllowed;
    });

    const invalidFill = this.state.summary.find((row) => {
      let total = 0;

      const totalReturnQtyConvert = (row.return || [])
        .reduce((sum, r) => sum + (r.qtyConvert || 0), 0);
     
      const maxAllowed = (row.total_convert || 0);
      total = totalReturnQtyConvert - (row.total_sell || 0);
      return total <= 0;
    });
    

    if (invalidRow) {
      alert("Harap pilih gudang (warehouse) untuk semua item sebelum menyimpan!");
      return;
    } else if(invalidRecord){
      alert("Harap isi semua Qty item sebelum menyimpan!");
      return;
    } else if(invalidTotal){
      alert(`Data tidak valid . Harap Periksa kembali Hasil Convert `);
      return;
    } else if(invalidFill){
      alert(`Data tidak valid . Harap Isi Qty`);
      return;
    }

    const post={
      idEmployee:this.state.idEmployee,
      idBranch:this.state.branchCurrent != null ? this.state.branchCurrent.value : '',
      idStore:this.state.storeCurrent != null ? this.state.storeCurrent.value : '',
      summary:summary,
      takingGoods:takingGoods,
    }

    return post
  }

  saveData(){
    const summary = this.state.summary;
    const invalidRow = summary.find((row, index) => {
      return !row.warehouse || !row.warehouse.value;
    });

    const invalidRecord = this.state.summary.find((row, index) => {
        return !row.return || row.return.length  == 0;
    });

    if (invalidRow) {
      alert("Harap pilih gudang (warehouse) untuk semua item sebelum menyimpan!");
      return;
    } else if(invalidRecord){
      alert("Harap isi semua Qty item sebelum menyimpan!");
      return;
    }

    const post={
      idEmployee:this.state.idEmployee,
      idBranch:this.state.branchCurrent != null ? this.state.branchCurrent.value : '',
      idStore:this.state.storeCurrent != null ? this.state.storeCurrent.value : '',
      summary:summary,
    }

    this.props.saveReturnGoods(post)

  }
  
  setSummary = (newSummary) => {
      this.setState({ summary: newSummary });
    };

  render() {
    const { helper,dataGoods,isProcessing, showData} = this.props;
    if (helper != null && helper.branch != undefined) {
      this.state.branchList = helper.branch;
    }
    this.state.dataTaking = dataGoods?.return || [];
    console.log('STATE',this.state)
    return (
        <div
          id="kt_content_container" className="d-flex flex-column-fluid align-items-start container-fluid">
          <div className="content flex-row-fluid" id="kt_content">
            <div className="card">
              <div className="card-body pt-3">
                <div className="row mb-4">
                  <div className="col-sm-3">
                    <Select2
                      isClearable={true}
                      name={"idBranch"}
                      required={true}
                      onChange={async (e) => {
                        if (e != this.state.branchCurrent) {
                          await this.setState({
                            storeList: [],
                            storeCurrent: null,
                            idStore: null,
                            employeeList: [],
                            employeeCurrent: null,
                            idEmployee: null,
                            loadingStore:true,
                            loadingEmployee:true,
                          });
                          await this.handlerSelect(
                            e,
                            "idBranch",
                            "branchCurrent"
                          );
                          await this.getData("getStore",()=>{
                            this.setState({ loadingStore:false})
                          });
                          await this.getData("getEmployee",()=>{
                            this.setState({ loadingEmployee:false})
                          });
                        }
                      }}
                      options={this.state.branchList}
                      title={i18n.t("Branch")}
                      value={this.state.branchCurrent}
                      currentState={"branchCurrent"}
                      placeholder={this.state.branchText}
                      error={this.renderError("idBranch")}
                    />
                  </div>
                  <div className="col-sm-3">
                    <Select2
                      isClearable={true}
                      isLoading={this.state.loadingStore}
                      name={"idStore"}
                      required={false}
                      onChange={async (e) => {
                        if (e != this.state.storeCurrent) {
                          await this.setState({
                            employeeList: [],
                            employeeCurrent: null,
                            idEmployee: null,
                            loadingEmployee:true,
                          });
                          await this.handlerSelect(
                            e,
                            "idStore",
                            "storeCurrent"
                          );
                          await this.getData("getEmployee",()=>{
                            this.setState({ loadingEmployee:false})
                          });
                        }
                      }}
                      options={this.state.storeList}
                      title={i18n.t("Store")}
                      value={this.state.storeCurrent}
                      currentState={"storeCurrent"}
                      placeholder={this.state.storeText}
                      error={this.renderError("idStore")}
                    />
                  </div>
                  <div className="col-sm-3">
                    <Select2
                      isClearable={true}
                      name={"idEmployee"}
                      required={true}
                      isLoading={this.state.loadingEmployee}
                      onChange={(e) =>
                        this.handlerSelect(e, "idEmployee", "employeeCurrent")
                      }
                      options={this.state.employeeList}
                      title={i18n.t("Employee")}
                      value={this.state.employeeCurrent}
                      currentState={"employeeCurrent"}
                      placeholder={this.state.employeeText}
                      error={this.renderError("idEmployee")}
                    />
                  </div>
                  <div className="col-sm-6 d-flex gap-5">
                    <Button
                      onClick={(e) => {
                        this.showData();
                      }}
                      disabled={
                        isProcessing
                      }
                      variant="success"
                      className="btn btn-md btn btn-success mt-8 "
                    >
                      {isProcessing ? 
                        <span className="indicator-progress " >{i18n.t("Please wait")}...
                          <span className="spinner-border spinner-border-sm align-middle ms-2"></span>
                        </span> 
                        : 
                        <span className="indicator-label"><FontAwesomeIcon icon={faEye}></FontAwesomeIcon> {i18n.t("Show")}</span>
                      }
                      
                    </Button>
                  </div>
                </div>
                <div className="row">
                  {(showData && dataGoods != undefined && dataGoods != null && !isProcessing)?
                      <DataReturn
                        {...dataGoods}
                        setSummary={this.setSummary}
                      ></DataReturn>
                    :null }
                </div>
              </div>
            </div>
          </div>
        </div>
    );
  }
}

export default FormReturnGoods;
